import type { GlobalScope } from '@xingternal/crate-xinglet/src';

export function register(
  globalScope: GlobalScope,
  dependency: string,
  value: Record<string, unknown> | (() => Promise<Record<string, unknown>>)
): void {
  (globalScope.crateImports ??= {})[dependency] =
    typeof value === 'function' ? () => value() : value;
}
